import { Component, Input } from '@angular/core';

import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';

@Component({
  selector: 'entity-details-client',
  templateUrl: './entity-details-client.component.html'
})

export class EntityDetailsClientComponent {
  @Input() entityIdDetails: EntityIdDetails;
  entityType = 'Client';

  constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/entitydetailsclient/entity-details-client.component.ts